import { render } from "./BaseCheckbox.vue?vue&type=template&id=dbb213b0&scoped=true&ts=true&lang=pug"
import script from "./BaseCheckbox.vue?vue&type=script&lang=ts"
export * from "./BaseCheckbox.vue?vue&type=script&lang=ts"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=dbb213b0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb213b0"]])

export default __exports__